
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
components: {
TransferDom,
Popup,
PopupPicker,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
Cell,
Toast
},
mounted() {
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
this.getBusinessInfo();
let tag = this.$route.query.tag;
let id=this.$route.query.id;
this.ComplaintType=this.$route.query.type;
if(tag=='A'){
this.isAdd=true;
if(this.ComplaintType==0){
this.TypeName="投诉商家";
this.TypeNameTip="选择"+this.TypeName;
}
else if(this.ComplaintType==1){
this.TypeName="投诉买家";
this.TypeNameTip="选择"+this.TypeName;
}
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无附件图片'});
}
else{
this.isAdd=false;
this.complaintDetail=this.GLOBAL.currentObjs[id];
if(this.complaintDetail.AttachInfos!=null){
if(this.complaintDetail.AttachInfos.length==0){
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无附件图片'});
}
else{
let index=1;
this.complaintDetail.AttachInfos.forEach(element => {
this.imgUrl.push({
url: '/ShowImgPage?path='+element.Path.replace("\\","/"),//process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
img: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
fallbackImg: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
title: '资质图片'+index
});
index++;
});
}
this.imgCount=this.complaintDetail.AttachInfos.length;
}
}
},
methods: {
onChange (val) {
console.log('val change', val);
this.selectedIndex=this.businessInfos[0].findIndex(item=>item==val);

},
onShow () {
console.log('on show')
},
onHide (type) {
console.log('on hide', type)
},
Save(){
if(this.isAdd==true){
this.complaintDetail.Complainter=this.GLOBAL.currentUser.BusinessGuid;
this.complaintDetail.ObjGuid=this.businessGuids[0][this.selectedIndex];
this.complaintDetail.ComplaintType=this.ComplaintType;
this.complaintDetail.attachGuids=this.attachGuids;

post('/complaintinfo/add', this.complaintDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
else if(this.isAdd==false){
this.complaintDetail.attachGuids=this.attachGuids;
post('/complaintinfo/update', this.complaintDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
}
},
Cancel(){

},
getBusinessInfo(){
post('/Business/query', {GetCredential:0}).then(response => {

if(response.code==1){
let _businessInfos=[];
let _businessGuids=[];
response.data.forEach(element => {
_businessInfos.push(element.BusinessName);
_businessGuids.push(element.BusinessGuid);
});
this.businessGuids.push(_businessGuids);
this.businessInfos.push(_businessInfos);
if(this.isAdd==false){
this.currentBusiness=[];
let _index=this.businessGuids[0].findIndex(item=>item==this.complaintDetail.ObjGuid);
this.currentBusiness.push(this.businessInfos[0][_index]);
}
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
addAttach(){
this.fileList.splice(0, this.fileList.length);
this.selectFiles='未选择附件图片';
this.showUpload=true;
},
UploadFile(){
if(this.fileList.length==0){
this.showWarn=true;
this.WarnInfo="未选择需要上传的附件图片";
return;
}
post('/file/upload', this.fileformData).then(response => {

if(response.code==1){
if(this.imgCount==0){
this.imgUrl=[];
}
let index=this.imgCount+1;
response.data.forEach(element => {


this.imgUrl.push({
url: '/ShowImgPage?path='+element.Path.replace("\\\\","/"),//process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\\\","/"),
img: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\\\","/"),
fallbackImg: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\\\","/"),
title: '附件图片'+index});
index++;
});

this.imgCount=this.imgUrl.length;
post('/attachinfo/add/batch/complaint', response.data).then(response1 => {

if(response1.code==1){
this.attachGuids=response1.data;

this.showUpload=false;
}
else if(response1.code==0){
this.showError=true;
}
else if(response1.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error1 => {
console.log(error1);
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
change(e) {
if (e.target.files.length > 0) {
this.getUrl(e.target.files); 
}
},
getUrl(file) {
console.log("getUrl", file)
this.selectFiles="共选择"+file.length+"个图片";

let _this = this;
this.fileformData = new FormData();

for (let i = 0; i < file.length; i++) {
this.fileformData.append("file", file[i]);
this.fileList.push(file[i].name);
}
}
},
data () {
return {
complaintDetail:{
attachGuids:[],
Title:'',
Content:'',
ComplaintDate:dateFormat(new Date(), 'YYYY年MM月DD日 HH时mm分')
},
isAdd:false,
currentBusiness:[],
businessInfos:[],
businessGuids:[],
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'投诉成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
ComplaintType:0,
selectedIndex:-1,
TypeName:'投诉商家',
TypeNameTip:'选择投诉商家',
imgUrl:[],
img_index:0,
imgCount:0,
showUpload:false,
fileList:[],
selectFiles:'未选择资质图片',
fileformData:[],
attachGuids:[]
}
}
}



// WEBPACK FOOTER //
// ./src/components/BusinessModules/ComplaintAction.vue